<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="ptl-results-range-chart" role="group" [attr.aria-label]="'Results range chart'">
  <div class="left-col" aria-hidden="false" *ngIf="legend?.length">
    <div class="label-row" *ngFor="let item of legend">
      <div class="label-name">
        {{ item.label }}
      </div>
    </div>
  </div>

  <div class="scale-col">
    <div class="scale-track" role="presentation">
      <div class="baseline" role="presentation"></div>
      <div
        class="bar-indicator bar--self"
        ogAnimateOnScroll
        (visible)="animate = true"
        [style.width]="avgUserPercent ? avgUserPercent : '0%'"
        [style.--bar-width]="avgUserPercent ?? '0%'"
      >
        <span class="bar-label">{{ avgUserPercent }}</span>
      </div>

      <div
        class="bar-indicator bar--avg"
        *ngIf="providersAverageValue !== null"
        ogAnimateOnScroll
        (visible)="animate = true"
        [style.width]="avgProvidersPercent ? avgProvidersPercent : '0%'"
        [style.--bar-width]="avgProvidersPercent ?? '0%'"
      >
        <span class="bar-label">{{ avgProvidersPercent }}</span>
      </div>
    </div>
  </div>
</div>
